import { DIRECTIONS, DirectionCode, PhotoSection, SECTIONS } from "./photoModel";

export interface BulkEditBarProps {
  count: number;
  onSetSection(s: PhotoSection): void;
  onSetDirection(d: DirectionCode): void;
  onDelete(): void;
  onClear(): void;
}

export default function BulkEditBar({ count, onSetSection, onSetDirection, onDelete, onClear }: BulkEditBarProps) {
  if (count === 0) return null;
  return (
    <div className="flex flex-wrap items-center gap-x-2 gap-y-1.5 px-4 py-2.5 border-b border-blue-200 bg-blue-50">
      {/* Selection count */}
      <span className="text-sm font-semibold text-blue-900 mr-1">เลือก {count} รูป</span>

      {/* Divider */}
      <span className="hidden sm:block h-4 w-px bg-blue-200" aria-hidden="true" />

      {/* Section group */}
      <span className="text-[10px] font-semibold uppercase tracking-wide text-blue-700">Section:</span>
      {SECTIONS.map((s) => (
        <button
          key={s}
          type="button"
          onClick={() => onSetSection(s)}
          className="rounded-md border border-blue-200 bg-white px-2.5 py-1 text-xs font-medium text-blue-700 hover:bg-blue-50 transition-colors"
        >
          {s}
        </button>
      ))}

      {/* Divider */}
      <span className="hidden sm:block h-4 w-px bg-blue-200" aria-hidden="true" />

      {/* Direction group */}
      <span className="text-[10px] font-semibold uppercase tracking-wide text-blue-700">มุม:</span>
      {DIRECTIONS.map((d) => (
        <button
          key={d.code}
          type="button"
          aria-label={d.label}
          title={`${d.code} → ${d.angle} (${d.label})`}
          onClick={() => onSetDirection(d.code)}
          className="rounded-md border border-blue-200 bg-white px-2.5 py-1 text-xs font-medium text-blue-700 hover:bg-blue-50 transition-colors"
        >
          {d.code}
        </button>
      ))}

      {/* Divider */}
      <span className="hidden sm:block h-4 w-px bg-blue-200" aria-hidden="true" />

      {/* Delete */}
      <button
        type="button"
        onClick={onDelete}
        className="rounded-md border border-red-200 bg-white px-2.5 py-1 text-xs font-medium text-red-600 hover:bg-red-50 transition-colors"
      >
        ลบ
      </button>

      {/* Clear selection */}
      <button
        type="button"
        onClick={onClear}
        className="ml-auto text-xs font-medium text-blue-600 underline underline-offset-2 hover:text-blue-800 transition-colors"
      >
        ยกเลิกเลือก
      </button>
    </div>
  );
}
